export default {"src":"/_next/static/media/red-heart-iconNew.34cba2a3.svg","height":24,"width":24};